import PaymentDetailsContainer from "../../../components/applications/eCommerce/paymentDetails";

const PaymentDetails = () => {
  return <PaymentDetailsContainer />;
};

export default PaymentDetails;
